var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("label", [
    _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
    _c("input", {
      ref: "input",
      class: _vm.className,
      attrs: { type: "text", placeholder: _vm.placeholder },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }